export const columns = [
  {
    title: 'Person',
    field: 'teamMemberName',
    align: 'left',
    type: 'string',
    sticky: true
  },
  {
    title: 'IIB Key',
    field: 'projectIibKey',
    align: 'left',
    type: 'string',
    sticky: true,
    collapsible: true
  },
  {
    title: 'IPB Key',
    field: 'projectIpbKey',
    align: 'left',
    type: 'string',
    sticky: true,
    collapsible: true
  },
  {
    title: 'Assigned Project',
    field: 'projectName',
    align: 'left',
    type: 'string',
    sticky: true
  },
  {
    title: 'Role',
    field: 'assignedRole',
    align: 'left',
    type: 'string',
    sticky: true,
    collapsible: true
  },
  {
    title: 'Start Date',
    field: 'startDate',
    align: 'left',
    type: 'date',
    sticky: true,
    collapsible: true
  },
  {
    title: 'End Date',
    field: 'endDate',
    align: 'left',
    type: 'date',
    sticky: true,
    collapsible: true
  },
  {
    title: 'T-Shirt Size',
    field: 'projectTShirtSize',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'Project Stage',
    field: 'projectMilestoneStage',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'Estimated Workload',
    field: 'estimatedWorkload',
    align: 'left',
    type: 'number',
    collapsible: true
  },
  {
    title: 'T-Shirt Size Multiplier',
    field: 'tshirtSizeMultiplier',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'Real Effort',
    field: 'realEffort',
    align: 'left',
    type: 'number',
    collapsible: true
  },
  {
    title: 'Total available (h)',
    field: 'totalAvailable',
    align: 'left',
    type: 'number',
    collapsible: true
  },
  {
    title: 'Total timeoff (h)',
    field: 'totalTimeOff',
    align: 'left',
    type: 'number',
    collapsible: true
  },
  {
    title: 'Real availability (h)',
    field: 'realAvailability',
    align: 'left',
    type: 'number',
    collapsible: true
  },
  {
    title: 'Total Effort (h)',
    field: 'totalEffortHours',
    align: 'left',
    type: 'number',
    collapsible: true
  },
  {
    title: 'Effort (md)',
    field: 'totalEffortManDays',
    align: 'left',
    type: 'number',
    collapsible: true
  }
]
